import React, { forwardRef } from "react";
import { Box } from "@mui/material";

const CustomDropdownIcon = forwardRef(({ className, onClick }, ref) => {
  return (
    <Box
      component="img"
      src="/newdashboard/Dropdown.png" // Replace with your image path
      alt="dropdown icon"
      ref={ref}
      className={className}
      onClick={onClick}
      sx={{
        width: 18,
        height: 18,
        cursor: "pointer",
      }}
    />
  );
});

export default CustomDropdownIcon;
